<template>
  <BaseWrapper :loading="loading">
    <div class="space-y-4">
      <div class="flex gap-2 justify-end">
        <PromoSelectSearch :inset="false" label="" :shadow="false" :request-params="{ 'filter[stock_exported]': true }" v-model="filter.promo" @change="onPromoChange" />
        <BaseInput v-if="filter.promo?.id" placeholder="Cari Kode Barang" :shadow="false" type="text" v-model="filter.search" />
        <BaseButton color="white" :to="{ name: 'stock-promo.index' }">
          <Icon icon="heroicons:arrow-uturn-left" class="h-4 w-4" />
          Kembali
        </BaseButton>
      </div>

      <AlertMessage
        v-if="!filter.promo?.id"
        type="warning"
        message="Promo belum dipilih"
      />

      <Datatable
        v-else
        :columns="[
          {
            id: 'name',
            name: 'Nama Bundle',
          },
          {
            id: 'product_code',
            name: 'Kode Produk',
          },
          {
            id: 'product_type',
            name: 'Tipe Produk',
          },
          {
            id: 'min_qty',
            name: 'Jumlah',
          },
          {
            id: 'stock',
            name: 'Stok',
          },
          {
            id: 'global_stock',
            name: 'Promo Global',
          },
          {
            id: 'quota_qty',
            name: 'Reimburse',
          },
          {
            id: 'shipped_qty',
            name: 'Sisa Kuota',
          },
        ]"
      >
        <template #tbody="{ classes }">
          <template v-for="productBundle in displayProductBundles">
            <tr :key="productBundle.id" class="bg-white">
              <td :class="classes.td" colspan="9">{{ productBundle.attributes.bundle_name }}</td>
            </tr>

            <tr v-for="requirement in getIncludedByType(productBundles, 'requirements', productBundle)" :key="`${productBundle.id}-reguler-${requirement.id}`" class="bg-gray-50">
              <td></td>
              <td :class="classes.td">{{ requirement.attributes.product_code }}</td>
              <td :class="classes.td">Barang Syarat</td>
              <td :class="classes.td">{{ requirement.attributes.min_qty }}</td>
              <td :class="classes.td">{{ requirement.attributes.stock }}</td>
              <td :class="classes.td">{{ getGlobalStock(requirement.attributes.product_code) }}</td>
              <td colspan="2"></td>
            </tr>

            <tr v-for="bonus in getIncludedByType(productBundles, 'bonuses', productBundle)" :key="`${productBundle.id}-bonus-${bonus.id}`" class="bg-gray-50">
              <td></td>
              <td :class="classes.td">{{ bonus.attributes.product_code }}</td>
              <td :class="classes.td">Barang Bonus</td>
              <td :class="classes.td">{{ bonus.attributes.qty }}</td>
              <td :class="classes.td">{{ bonus.attributes.stock }}</td>
              <td :class="classes.td">{{ getGlobalStock(bonus.attributes.product_code) }}</td>
              <td :class="classes.td">{{ bonus.attributes.received_qty }}/{{ bonus.attributes.quota_qty }}</td>
              <td :class="classes.td">{{ bonus.attributes.quota_qty - bonus.attributes.received_qty }}</td>
            </tr>
          </template>
        </template>
      </Datatable>
    </div>
  </BaseWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PromoSelectSearch from '../../../../components/promo/PromoSelectSearch.vue';
import { requestMixin } from '../../../../mixins/request/request.js';
import AlertMessage from '../../../../components/base/AlertMessage.vue';

export default {
  mixins: [requestMixin],
  components: {
    PromoSelectSearch,
    AlertMessage
  },
  data() {
    return {
      loading: false,
      filter: {
        promo: null,
        search: null
      },
      productBundles: {
        data: [],
        included: [],
        meta: {
          warehouse_stocks: {},
        }
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser'
    }),
    displayProductBundles() {
      if (!this.filter.search) {
        return this.productBundles.data
      }

      return this.productBundles.data.filter(bundle => {
        const requirements = this.getIncludedByType(this.productBundles, 'requirements', bundle)

        if (requirements.some(requirement => requirement.attributes.product_code.toLowerCase().includes(this.filter.search.toLowerCase()))) {
          return true
        }

        const bonuses = this.getIncludedByType(this.productBundles, 'bonuses', bundle)

        if (bonuses.some(bonus => bonus.attributes.product_code.toLowerCase().includes(this.filter.search.toLowerCase()))) {
          return true
        }

        return false
      })
    }
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert'
    }),
    getGlobalStock(code) {
      if (!this.productBundles.meta.warehouse_stocks[code]) {
        return 0
      }

      return this.productBundles.meta.warehouse_stocks[code].stock_qty - this.productBundles.meta.warehouse_stocks[code].stock_ordered
    },
    async onPromoChange() {
      if (this.filter.promo.id) {
        this.loading = true;

        const [res, err] = await this.request(`/api/v1/offices/${this.me.office_id}/promo-bundles`, {
          params: {
            'filter[promo_id]': this.filter.promo.id,
            'include': 'requirements,bonuses'
          }
        });

        if (!err) {
          this.filter.search = null
          this.productBundles = res;
        }

        this.loading = false;
      }
    },
  }
}
</script>